import { render, staticRenderFns } from "./inventoryTransactionDetailsModal.vue?vue&type=template&id=4e506e65&scoped=true"
import script from "./inventoryTransactionDetailsModal.vue?vue&type=script&lang=js"
export * from "./inventoryTransactionDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e506e65",
  null
  
)

export default component.exports